<template>
  <div :class="[classes.cardFooter, layoutClass]">
    <StakeAmount
      v-if="!isPotentialWinnings"
      :class="[classes.cardFooterElemBase]"
    />
    <ReturnButton
      :class="[classes.cardFooterElemBase]"
      :hasPicks="previewPicks"
    />
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { computed, defineComponent } from "vue";
import {
  injectBrand,
  BrandContext
} from "@fresh8/ad-data-composition/src/brand";
import { injectLayout, SMALL_RESPONSIVE } from "../../../../hooks/useLayout";
import StakeAmount from "../StakeAmount.vue";
import ReturnButton from "../ReturnButton.vue";
import { oddsTypeEnum } from "@fresh8/types/src";

const useStyles = createUseStyles({
  cardFooter: {
    width: "100%",
    borderTop: props => `1px solid ${props.marketBorderColor || "#dcddf"}`,
    display: "flex",
    justifyContent: "space-between",
    fontSize: "10px",
    padding: "4px 8px",
    height: "43px",
    boxSizing: "border-box",
    alignItems: "center",
    flex: "none",
    fontFamily: "Arial",
    fontWeight: "bold",
    textTransform: "uppercase",
    [`&.${SMALL_RESPONSIVE}`]: {
      height: "17px",
      flex: "1 0 17px",
      padding: "0 6px",
      maxHeight: "17px"
    }
  },
  cardFooterElemBase: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  }
});

export default defineComponent({
  name: "MPUParlayCardFooter",
  components: {
    StakeAmount,
    ReturnButton
  },
  props: {
    previewPicks: { type: Boolean, required: false, default: false }
  },
  setup() {
    const { layout } = injectLayout();
    const {
      adTemplateBranding,
      oddsDisplayTemplate
    } = injectBrand() as BrandContext;

    const classesRef = useStyles(
      computed(() => ({
        marketBorderColor: adTemplateBranding.value.marketBorderColor
      }))
    );

    return {
      classes: classesRef,
      layoutClass: computed(() => layout.value),
      isPotentialWinnings: computed(
        () => oddsDisplayTemplate.value === oddsTypeEnum.POTENTIAL_WINNINGS
      )
    };
  }
});
</script>
